import { trackEvent } from '@/features/common/helpers/google-analytics';

// --- Create Shipment flow ---
export async function trackCreateFormStart(gtag) {
  await trackEvent(gtag, 'create_form_start', {
    event_category: 'Create Shipment',
  });
}

export async function trackCreateFormSubmit(
  gtag,
  data: {
    shipmentType: string;
    carrier: string;
    originCountry: string;
    destinationCountry: string;
  },
) {
  await trackEvent(gtag, 'create_form_submit', {
    event_category: 'Create Shipment',
    shipment_type: data.shipmentType,
    carrier: data.carrier,
    origin_country: data.originCountry,
    destination_country: data.destinationCountry,
  });
}

export async function trackCreateFormError(
  gtag,
  data: { field: string; message: string; step: string },
) {
  await trackEvent(gtag, 'create_form_error', {
    event_category: 'Create Shipment',
    field: data.field,
    message: data.message,
    step: data.step,
  });
}

export async function trackCreateFieldComplete(
  gtag,
  data: { field: string },
) {
  await trackEvent(gtag, 'create_field_complete', {
    event_category: 'Create Shipment',
    field: data.field,
  });
}

// --- Shipment completion ---
export async function trackShipmentCompleted(
  gtag,
  data: { shipmentId: string; value: number },
) {
  const dedupKey = `tracked_${data.shipmentId}`;
  if (sessionStorage.getItem(dedupKey)) return;
  sessionStorage.setItem(dedupKey, '1');

  await trackEvent(gtag, 'shipment_completed', {
    shipment_id: data.shipmentId,
    value: data.value,
  });
}

// --- Payment flow ---
export async function trackPaymentInitiated(
  gtag,
  data: { value: number; currency: string; paymentMethod: string },
) {
  await trackEvent(gtag, 'payment_initiated', {
    event_category: 'Payment',
    value: data.value,
    currency: data.currency,
    payment_method: data.paymentMethod,
  });
}

export async function trackPaymentComplete(
  gtag,
  data: { value: number; currency: string; paymentMethod: string },
) {
  await trackEvent(gtag, 'payment_complete', {
    event_category: 'Payment',
    value: data.value,
    currency: data.currency,
    payment_method: data.paymentMethod,
  });
}
